/**
 * created by li si yi
 * 系统设置-业务开关-业务维护
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../../base/BaseComponent";
import { Icon, Tabs, Tree} from 'antd';
import UploadFile from "../btn/Upload"
import {uuid} from '../../../../utils'
import {Scrollbars} from "react-custom-scrollbars";
import {PIC_TYPE, VIDEO_TYPE} from "../../../../constants";

const {TreeNode} = Tree;

const {TabPane} = Tabs;
export default class TaskPicture extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            expandedKeys: '',
            fid: '',  //当前任务的id 不变的
            autoExpandParent: '',
            treeData: [],
            currentId: '',//左侧树点击那个 就是那个的id 当前点击的id,
            treeId:'' ,//树ID 不变的
            dataSource: [],
            current:'',//  2代表图片 3代表视频
            showDelete:true, //任务图片 任务视频是否有删除权限
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.state.fid = this.props.id;
        this.state.current = this.props.current;
        this.setState({}, () => {
            this.getCurrentData()
        })
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (this.state.fid !== nextProps.id || this.state.current!==nextProps.current) {
            this.state.fid = nextProps.id;
            this.state.current= nextProps.current;
            this.state.upLoadKey = uuid();
            this.setState({}, () => {
                this.getCurrentData()
            })
        }
    }
    getCurrentData(){
        this.getData( this.state.fid,(res)=>{
            this.init(res)
        })
    }
    init(res){
        let newData  = res&&res.taskReporterObjs?res.taskReporterObjs:[];
        let myRole = newData.filter(item=>(item.reporter.name==window.currentUser.name && item.reporter.account==window.currentUser.account&&item.reporter.currentDept?.id===window.currentUser.defaultInfo?.dept?.id));
        let showDelete = true;
        if(this.props.current==='2'){
            this.state.currentId = res.taskPicture;
            this.state.treeId = res.taskPicture;
            if(myRole&&myRole.length&&myRole[0].status !=='未领取'&&myRole&&myRole[0].taskRole.length&&myRole[0].taskRole.indexOf('摄影记者')>-1){
                showDelete = false
            }
        }else{
            if(myRole&&myRole.length&&myRole[0].status !=='未领取'&&myRole&&myRole[0].taskRole.length&&myRole[0].taskRole.indexOf('摄像记者')>-1){
                showDelete = false
            }
            this.state.currentId = res.taskVideo;
            this.state.treeId = res.taskVideo
        }
        this.state.showDelete = showDelete;
        this.setState({},()=>{
          this.getLeftData()
        })
    }
    componentWillUnmount() {
    }
    //根据id 获取数据
    getData(id, call) {
        let url = '/cm-sites-business/bd/busTask/getById/';
        this.request({
            url: "" + url + id,
            method: "post",
            body: {
                "showRef": [
                    "taskReporterIds",
                    "clueId",
                    "topicSelectionId"
                ]
            },
            contentType: 'json',
            callBack: (data) => {

              call&&call(data)
            }
        });
    }
    //获取右侧的列表
    getRightList() {
        this.request({
            url: "/cm-sites-storage-management/interview/resourceChild?fid=" + this.state.currentId,
            method: "get",
            contentType: 'json',
            callBack: (data) => {
                let array = [];
                if (data && data.length > 0) {
                    array = data;
                }
                this.setState({dataSource:array},()=>{
                    this.props.callBackArray && this.props.callBackArray(array)
                })
            }
        });
    }
    getAllData(fileList,file){
        let array = this.state.dataSource;
      
        fileList && fileList.length && fileList.forEach((item, ids) => {

            let findResult = array.find(arrayItem=>arrayItem.id && (arrayItem.id === item.id));
            if(!findResult){
                findResult = array.find(arrayItem=>arrayItem.uid && (arrayItem.uid === item.uid));
            }
            if(!findResult){
                if(item.name){
                    if(this.props.current ==='2'){
                      if(PIC_TYPE.find(Item => item.name.endsWith(Item)))  {
                          array.push(item);
                      }

                    }else{
                        if(VIDEO_TYPE.find(Item => item.name.endsWith(Item)))  {
                            array.push(item);
                        }
                    }
                }
            }else{
                findResult.status = item.status;
            }
        });
        array&&array.length&&array.forEach(item=>{
            if(item?.uid === file.uid){
                item.id = file.id
            }
        });
        this.setState({dataSource:array},()=>{
        })
   }
    //获取左侧的树结构
    getLeftData() {
        let name;
        if(this.state.current === '2'){
            name = '全部图片'
        }else if(this.state.current === '3'){
            name = '全部视频'
        }
        this.request({
            url: "/cm-sites-storage-management/interview/resourceList?fid=" + this.state.currentId+'&name='+name,
            method: "get",
            contentType: 'json',
            callBack: (data) => {
                if (data) {
                    this.state.treeData = [data];
                    this.setState({}, () => {
                        this.getRightList()
                    })
                }
            }
        });
    }

    render() {
        let {treeData} = this.state;
        return (
            <div style={{display: 'flex',}}>
                <div style={{width: '150px', borderRight: '1px solid  rgba(0, 0, 0, 0.06)', height: '445px'}}>
                    <Scrollbars autoHeight autoHeightMax={445}>
                        <Tree
                            onSelect={this.onSelect}
                            selectedKeys={[this.state.currentId]}
                            showIcon
                        >
                            {this.renderTreeNodes(treeData)}
                        </Tree>
                    </Scrollbars>
                </div>
                <div style={{width: '630px'}}> {this.renderRight()}</div>
            </div>
        )
    }

    renderTreeNodes = (treeData) => {

        return treeData.map(item => {
            // let child = [...(item.recursiveVirtualFiles || []), ...(item.virtualFiles || [])];
            let child = [...(item.recursiveVirtualFiles || [])];
            let thisFile = item.virtualFile;
            if (child && child.length) {
                return <TreeNode icon={<Icon type="folder-open" theme='filled' style={{color: " rgb(255, 205, 44"}}/>}
                                 title={thisFile.name ? thisFile.name : ''}
                                 key={thisFile.id} dataRef={item}>{this.renderTreeNodes(child)}</TreeNode>
            } else {
                return <TreeNode icon={<Icon type="file-text" theme="outlined"/>}
                                 title={thisFile && thisFile.name !== "null" ? thisFile.name : '11111'}
                                 key={thisFile && thisFile.id !== "null" ? thisFile.id : '11111'}>
                </TreeNode>

            }
        });
    };

    renderRight() {
        //current:当前是图片 还是视频
        return (
            <div style={{padding: '20px 8px'}}>
                <UploadFile dataSource={this.state.dataSource}
                            showCheck={this.props.showCheck}
                            current={this.props.current}
                            showDelete = {this.state.showDelete}
                            deleteCallBack ={(deleteList)=>{
                                this.props.deleteCallBack&& this.props.deleteCallBack(deleteList)
                            }}
                            callBack={(data) => {
                                this.setState({dataSource: data});
                                this.props.callBack && this.props.callBack(data)
                            }}>

                </UploadFile>
            </div>
        )
    }

    onSelect = (keys, e) => {
        if (e.selected) {
            this.state.currentId = keys;
            this.setState({}, () => {
                if (e.selected && keys == !['null']) {
                    this.getList()
                }
            })
        }
    };
}
